import React, { useState, useEffect } from 'react';

import { useAppSelector } from '@/store';
import { ServiceGroup } from '@/types/serviceGroup';
import { serviceGroupsApi } from '@/services/api';
import { authStore } from '@/store/auth';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

import { ServiceList } from '../Presentation';

export const ServiceListContainer: React.FC = () => {
  const { apiErrorHandler } = useApiErrorHandler();
  const isLoggedIn = useAppSelector(authStore.selectors.isLoggedInSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [services, setServices] = useState<ServiceGroup[]>([]);

  useEffect(() => {
    (async () => {
      if (isLoggedIn) {
        setIsLoading(true);

        try {
          const services = await serviceGroupsApi.getList();
          setIsLoading(false);
          setServices(services);
        } catch (e) {
          setIsLoading(false);
          apiErrorHandler(e);
        }
      }
    })();
  }, [apiErrorHandler, isLoggedIn]);

  const childProps = { isLoading, services };
  return <ServiceList {...childProps} />;
};
